import React from "react";
import TableTemplate from "../../TableTemplate/tableTemplate";
import { CommonTableUI } from "../../TableTemplate/common";
import { getOptionGreekConstraintTable } from "../../../Requests/optionGreek";
import { IOptionsGreekConstraintTableReport } from "../../../Interfaces/optionGreek";
import TableUI from "./TableUI";

interface IProps {
  onTableRowClick: (row: IOptionsGreekConstraintTableReport) => void;
}

const ConstraintTable = ({ onTableRowClick }: IProps) => {
  return (
    <TableTemplate
      TableUI={({ reports, sortingType, setSortingType, onAction }) => (
        <TableUI
          reports={reports}
          tableBoxClassName="max-h-[500px]"
          sortingType={sortingType}
          setSortingType={setSortingType}
          onTableRowClick={onTableRowClick}
          onAction={onAction}
        />
      )}
      getDataTable={getOptionGreekConstraintTable}
      withSort
    />
  );
};

export default ConstraintTable;
